import React from 'react';
import { ThemeProvider, Theme, GlobalStyles } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import defaultTheme from './defaultTheme';

const navCssVars = {
  ':root': {
    '--nav-rail-width': '68px',
    '--nav-subpanel-width': '240px',
    '--nav-tab-pill-width': '52px',
    '--nav-radius-sm': '4px',
  },
};

interface AppThemeProviderProps {
  children: React.ReactNode;
  theme?: Theme;
}

const AppThemeProvider = ({ children, theme = defaultTheme }: AppThemeProviderProps) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalStyles styles={navCssVars} />
    {/*
      Publish the active theme's font family as a CSS variable so plain (non-MUI)
      stylesheets can consume it via var(--app-font-family, ...). This makes the
      theme file the single source of truth for typography: SPS themes resolve to
      Montserrat, all other tenants to Proxima Nova — no per-file duplication.
    */}
    <GlobalStyles styles={(t) => ({ ':root': { '--app-font-family': t.typography.fontFamily } })} />
    {children}
  </ThemeProvider>
);

export default AppThemeProvider;
